"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeStyle = void 0;
require("react");
require("../types");
const getSizeStyle = (size) => {
    const style = {};
    if (size === null || size === void 0 ? void 0 : size.width) {
        style.width = size.width;
    }
    if (size === null || size === void 0 ? void 0 : size.height) {
        style.height = size.height;
    }
    return style;
};
exports.getSizeStyle = getSizeStyle;
//# sourceMappingURL=getSizeStyle.js.map